"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const json_user_functions_1 = require("../../parsers/json/json-user-functions");
class Algorithm {
    constructor(algorithmJson) {
        this.name = algorithmJson.name;
        this.userFunctions = json_user_functions_1.parseUserFunctions(algorithmJson.userFunctions);
        this.tables = algorithmJson.tables;
    }
}
exports.Algorithm = Algorithm;
//# sourceMappingURL=algorithm.js.map